export enum PrintOrderStatus {
	RECEIVED = "received", // 1 - recieved by API from connector
	QUEUED = "queued", // 2 - submitted to SQS
	SUBMITTED = "submitted", // 3 - order sent to display
	PENDING = "pending", // 4 - pending Websocket message to device
	CONSUMED = "consumed", // 5 - order consumed by device
	DISPLAYED = "displayed", // 6 - displayed on kitchen station. As of build 20220415
	BUMPED = "bumped", // 7 - bumped by orders device
	REMOTEBUMP = "remotebump", // 7 - bumped remotely by device other then the intended device
	COMPLETE = "complete", // 7 - order complete and marked complete on expo device

	ERROR = "error", // XX - error occurred at some point
}
